<template>
  <section class="cabinet">
    <app-loading :is-loading="isLoading" />
    <div
      v-if="!isLoading && notificationDetail !== null"
      class="purchases__title-wrapper container"
    >
      <div class="search">
        <div class="row">
          <div class="col-12">
            <h1 class="search__title">
              {{ notificationDetail.title }}
            </h1>
            <p>{{ date }}</p>
            <div
              class="notification-detail"
              v-html="notificationDetail.description"
            />
          </div>

          <div class="col-12">
            <div class="purchases__form-buttons purchases__form-buttons--mt row d-flex justify-content-end">
              <router-link
                class="purchases__button"
                role="link"
                :to="{ name: 'NotificationList'}"
              >
                Вернуться к уведомлениям
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import { dateFormat } from '@/utils/helpers';

export default {
  name: 'NotificationDetail',
  data() {
    return {
      notificationID: null,
    };
  },
  async created() {
    this.notificationID = this.$route.params.notificationID;
  },
  async mounted() {
    await this.loadInfo();
    await this.loadNotificationDetail({ id: this.notificationID });

    this.actionFetchNotificationQuantity();
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.notifications.isLoading,
    }),
    ...mapState('notifications', ['notificationDetail']),
    date() {
      return dateFormat(this.notificationDetail.date);
    },
  },
  methods: {
    ...mapMutations('notifications', ['setProtocolDetailErrorText']),
    ...mapActions({
      loadInfo: 'user/loadInfo',
      loadNotificationDetail: 'notifications/loadNotificationDetail',
      actionFetchNotificationQuantity: 'notifications/fetchQuantity',
    }),
  },
};
</script>
<style lang="scss" scoped>
.search{
  max-width: 800px;
  margin: 60px auto;
}
.purchases__button{
  max-width: 350px;
}
</style>
<style lang="scss">
.notification-detail {
  background-color: #fff;
  padding: 20px 40px;
  font-family: 'Arial', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #3D3D3D;
  align-self: stretch;
  flex-grow: 0;
  max-width: 800px;

  p {
    margin: 0;
  }

  .td-container {
    padding: 0;
    Margin: 0;
  }

  .table-container {
    mso-table-lspace: 0;
    mso-table-rspace: 0;
    border-collapse: collapse;
    border-spacing: 0;
  }

  .td-valign-top-align-center {
    padding: 0;
    Margin: 0;
    width: 100%;
  }

  .h2-container {
    margin: 0;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 40px;
    padding-bottom: 40px
  }

  .h2-font {
    Margin: 0;
    line-height: 38px;
    mso-line-height-rule: exactly;
    font-family: arial, helvetica, sans-serif;
    font-size: 32px;
    font-style: normal;
    font-weight: normal;
    color: #3d3d3d;
  }

  .text-block {
    Margin: 0;
    padding-top: 5px;
    padding-bottom: 20px;
    padding-left: 40px;
    padding-right: 40px;
    line-height: 14px;
    font-size: 12px;
    color: #CCCCCC;
  }

  .text {
    margin: 0;
    padding: 0 0 20px 0;
    -webkit-text-size-adjust: none;
    -ms-text-size-adjust: none;
    mso-line-height-rule: exactly;
    font-family: arial, helvetica, sans-serif;
    line-height: 19px;
    color: #3d3d3d;
    font-size: 16px
  }

  .text--gray {
    margin: 0;
    -webkit-text-size-adjust: none;
    -ms-text-size-adjust: none;
    mso-line-height-rule: exactly;
    font-family: arial, helvetica, sans-serif;
    line-height: 17px;
    color: #979797;
    font-size: 14px
  }

  .text--link {
    margin: 0;
    -webkit-text-size-adjust: none;
    -ms-text-size-adjust: none;
    mso-line-height-rule: exactly;
    font-family: arial, helvetica, sans-serif;
    line-height: 19px;
    color: #77A730;
    font-size: 16px;
    text-decoration: none;
  }

}
</style>
